module.exports = __webpack_public_path__ + "static/safe_contractor_seal.1c95270f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Introduction/safe_contractor_seal.png
// module id = 457
// module chunks = 35783957827783